import { gql } from "@apollo/client";

export const MUTATION_UPDATE_USER = gql`
  mutation updateUsersPermissionsUser(
    $id: ID!
    $input: UsersPermissionsUserInput!
  ) {
    updateUsersPermissionsUser(id: $id, data: $input) {
      data {
        attributes {
          updatedAt
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_USER_WEEKLY = gql`
  mutation updateUserOnboardingWeeklyQuestions(
    $id: ID!
    $input: UsersPermissionsUserInput!
  ) {
    updateUsersPermissionsUser(id: $id, data: $input) {
      data {
        attributes {
          username
          onboardQuestionsCompleted
        }
      }
    }
  }
`;

// export const MUTATION_UPDATE_USER_TRACKING = gql`
//   mutation updateUserTracking($id: ID!, $input: UsersPermissionsUserInput!) {
//     updateUsersPermissionsUser(id: $id, data: $input) {
//       data {
//         attributes {
//           username
//           isEmotionWheelTrackingDisabled
//         }
//       }
//     }
//   }
// `;

export const MUTATION_UPDATE_STAFF_ONBOARD_LEADERSHIP_WHEEL = gql`
  mutation updateStaffOnboardLeadershipWheel(
    $id: ID!
    $input: UsersPermissionsUserInput!
  ) {
    updateUsersPermissionsUser(id: $id, data: $input) {
      data {
        attributes {
          username
          onboardLeadershipWheelCompleted
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_USER_SWIPE_HINT = gql`
  mutation updateUserSwipeHint($id: ID!, $input: UsersPermissionsUserInput!) {
    updateUsersPermissionsUser(id: $id, data: $input) {
      data {
        attributes {
          username
          # disableSwipeHint
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_USER_ONBOARDING_QUESTIONS = gql`
  mutation updateUserOnboardingQuestions(
    $id: ID!
    $input: UsersPermissionsUserInput!
  ) {
    updateUsersPermissionsUser(id: $id, data: $input) {
      data {
        attributes {
          username
          onboardQuestionsCompleted
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_USER_ONBOARDING = gql`
  mutation updateUserOnboarding($id: ID!, $input: UsersPermissionsUserInput!) {
    updateUsersPermissionsUser(id: $id, data: $input) {
      data {
        attributes {
          username
          onboardHomeCompleted
        }
      }
    }
  }
`;

export const MUTATION_ONBOARDING_FORM_UPDATE_USER = gql`
  mutation updateStaffProfile(
    $staffId: ID!
    $profile: String
    $gender: String
    $location: String
    $ageBracket: String
  ) {
    updateUsersPermissionsUser(
      id: $staffId
      data: {
        profile: $profile
        gender: $gender
        location: $location
        ageBracket: $ageBracket
      }
    ) {
      data {
        attributes {
          updatedAt
        }
      }
    }
  }
`;
